import gql from "graphql-tag";

export default gql`
	query countCurrencyTrader($attributes: FilterCurrencyTraderInput, $status: String) {
		countCurrencyTrader(attributes: $attributes, status: $status)
	}
`;
